import { createSvgIcon } from '@mui/material';

const NoCameraAccessIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M9.5 9.5H10.5472C10.8807 9.5 11.0475 9.5 11.1985 9.49086C13.1265 9.37409 14.8149 8.15719 15.5354 6.365C15.5918 6.22464 15.6445 6.06643 15.75 5.75C15.8555 5.43357 15.9082 5.27536 15.9646 5.135C16.6851 3.34281 18.3735 2.12591 20.3015 2.00914C20.4525 2 20.6193 2 20.9528 2H33.0472C33.3807 2 33.5475 2 33.6985 2.00914C35.6265 2.12591 37.3149 3.34281 38.0354 5.135C38.0918 5.27536 38.1445 5.43357 38.25 5.75C38.3555 6.06643 38.4082 6.22464 38.4646 6.365C39.1851 8.15719 40.8735 9.37409 42.8015 9.49086C42.9525 9.5 43.1304 9.5 43.486 9.5C44.4091 9.5 44.8706 9.5 45.2395 9.53654C48.7968 9.889 51.611 12.7032 51.9635 16.2605C52 16.6294 52 17.0673 52 17.9431V42C52 44.7123 50.5602 47.0883 48.4033 48.4055M34.6602 34.6785C36.1205 32.9403 37 30.6979 37 28.25C37 22.7272 32.5228 18.25 27 18.25C24.5539 18.25 22.313 19.1282 20.5753 20.5866M52 52L2 2M2 15.75V37.5C2 41.7004 2 43.8006 2.81745 45.4049C3.5365 46.8161 4.68386 47.9635 6.09507 48.6825C7.69941 49.5 9.79961 49.5 14 49.5H35.75M27 38.25C21.4772 38.25 17 33.7728 17 28.25"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'NoCameraAccessIcon',
  );
  return (
    <IconCmp
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      style={{ fill: 'none' }}
      {...props}
    />
  );
};
export default NoCameraAccessIcon;
